function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#7552F6",
  d: "M10.312 17.808L9 19.119 13.131 22.803 21 15.371 19.688 14.06 13.131 20.18z",
  transform: "rotate(-3 30.275 18.831)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/check-purple.6e1d0120.svg";
export { SvgComponent as ReactComponent };